module.exports = __webpack_public_path__ + "static/img/7.e2cca91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/home/7.png
// module id = bQKd
// module chunks = 1